import { memo } from 'react';
import { useApplySharedSearch } from './use-apply-shared-search';

/**
 * Headless mount point for `useApplySharedSearch`. Rendered once inside the
 * search layout (within scope + router context) so a `?search-id=` link is
 * applied to the params store on load.
 */
export const SharedSearchLoader = memo(() => {
  useApplySharedSearch();
  return null;
});

SharedSearchLoader.displayName = 'SharedSearchLoader';
